import React from 'react';

import ReactToolTip from 'react-tooltip';
export default class RightNav extends React.Component {
    render() {
        return (
            
            <div className="rhs-nav" >
                <ul className="rhs-nav-icons" data-tip = "Information">
                    <li className="stats_info_icon">
                        <span className="svg_wrap">
                            <svg
                                x="0px"
                                y="0px"
                                viewBox="0 0 22.4 22.9"
                                enableBackground="new 0 0 22.4 22.9"
                                xmlSpace="preserve">
                                <g>
                                    <path
                                        fill="#159ABD"
                                        d="M11.2,0.8C5.3,0.8,0.5,5.6,0.5,11.5s4.8,10.7,10.7,10.7s10.7-4.8,10.7-10.7S17.1,0.8,11.2,0.8z M13.4,17.4   c-0.6,0.2-1,0.4-1.3,0.5C11.8,18,11.4,18,11,18c-0.7,0-1.2-0.2-1.6-0.5c-0.4-0.3-0.6-0.7-0.6-1.2c0-0.2,0-0.4,0-0.6   C8.9,15.5,9,15.3,9,15l0.7-2.4c0.1-0.2,0.1-0.5,0.2-0.7c0-0.2,0.1-0.4,0.1-0.6c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.1-0.4-0.2-0.7-0.2   c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.1-0.5,0.2L8.2,10C8.6,9.8,9,9.7,9.5,9.5c0.4-0.1,0.8-0.2,1.2-0.2c0.7,0,1.2,0.2,1.5,0.5   c0.4,0.3,0.5,0.7,0.5,1.2c0,0.1,0,0.3,0,0.6c0,0.3-0.1,0.5-0.1,0.7l-0.7,2.4c-0.1,0.2-0.1,0.4-0.2,0.7c0,0.2-0.1,0.4-0.1,0.6   c0,0.3,0.1,0.5,0.2,0.7c0.1,0.1,0.4,0.2,0.8,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.1,0.5-0.2L13.4,17.4z M13.3,7.5   c-0.3,0.3-0.7,0.4-1.2,0.4c-0.4,0-0.8-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.5,1.2-0.5   c0.5,0,0.8,0.1,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.1C13.8,6.8,13.6,7.2,13.3,7.5z"></path>
                                </g>
                            </svg>
                        </span>

                    </li>

                </ul><ReactToolTip />
            </div >
        

        )
    }
}